'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var lp = require('it-length-prefixed');

var pipe = require('it-pipe');

var Message = require('./types/message');

var CONSTANTS = require('./constants');

var logger = require('./utils').logger;

var BITSWAP100 = '/ipfs/bitswap/1.0.0';
var BITSWAP110 = '/ipfs/bitswap/1.1.0';

var Network = /*#__PURE__*/function () {
  function Network(libp2p, bitswap, options, stats) {
    _classCallCheck(this, Network);

    this._log = logger(libp2p.peerInfo.id, 'network');
    options = options || {};
    this.libp2p = libp2p;
    this.bitswap = bitswap;
    this.protocols = [BITSWAP100];

    if (!options.b100Only) {
      // Latest bitswap first
      this.protocols.unshift(BITSWAP110);
    }

    this._stats = stats;
    this._running = false; // bind event listeners

    this._onPeerConnect = this._onPeerConnect.bind(this);
    this._onPeerDisconnect = this._onPeerDisconnect.bind(this);
    this._onConnection = this._onConnection.bind(this);
  }

  _createClass(Network, [{
    key: "start",
    value: function start() {
      this._running = true;
      this.libp2p.handle(this.protocols, this._onConnection);
      this.libp2p.on('peer:connect', this._onPeerConnect);
      this.libp2p.on('peer:disconnect', this._onPeerDisconnect); // All existing connections are like new ones for us

      var _iterator3 = _createForOfIteratorHelper(this.libp2p.peerStore.peers.values()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var peer = _step3.value;

          if (this.libp2p.registrar.getConnection(peer)) {
            this._onPeerConnect(peer);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this._running = false; // Unhandle both, libp2p doesn't care if it's not already handled

      this.libp2p.unhandle(this.protocols);
      this.libp2p.removeListener('peer:connect', this._onPeerConnect);
      this.libp2p.removeListener('peer:disconnect', this._onPeerDisconnect);
    }
    /**
     * Handles both types of incoming bitswap messages
     * @private
     * @param {object} param0
     * @param {string} param0.protocol The protocol the stream is running
     * @param {Stream} param0.stream A duplex iterable stream
     * @param {Connection} param0.connection A libp2p Connection
     * @returns {void}
     */

  }, {
    key: "_onConnection",
    value: function () {
      var _onConnection2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
        var _this = this;

        var protocol, stream, connection;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                protocol = _ref.protocol, stream = _ref.stream, connection = _ref.connection;

                if (this._running) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                this._log('incoming new bitswap %s connection from %s', protocol, connection.remotePeer.toB58String());

                _context2.prev = 4;
                _context2.next = 7;
                return pipe(stream, lp.decode(), /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, data, message;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _context.prev = 2;
                            _iterator = _asyncIterator(source);

                          case 4:
                            _context.next = 6;
                            return _iterator.next();

                          case 6:
                            _step = _context.sent;
                            _iteratorNormalCompletion = _step.done;
                            _context.next = 10;
                            return _step.value;

                          case 10:
                            _value = _context.sent;

                            if (_iteratorNormalCompletion) {
                              _context.next = 28;
                              break;
                            }

                            data = _value;
                            _context.prev = 13;
                            _context.next = 16;
                            return Message.deserialize(data.slice());

                          case 16:
                            message = _context.sent;
                            _context.next = 19;
                            return _this.bitswap._receiveMessage(connection.remotePeer, message);

                          case 19:
                            _context.next = 25;
                            break;

                          case 21:
                            _context.prev = 21;
                            _context.t0 = _context["catch"](13);

                            _this.bitswap._receiveError(_context.t0);

                            return _context.abrupt("break", 28);

                          case 25:
                            _iteratorNormalCompletion = true;
                            _context.next = 4;
                            break;

                          case 28:
                            _context.next = 34;
                            break;

                          case 30:
                            _context.prev = 30;
                            _context.t1 = _context["catch"](2);
                            _didIteratorError = true;
                            _iteratorError = _context.t1;

                          case 34:
                            _context.prev = 34;
                            _context.prev = 35;

                            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                              _context.next = 39;
                              break;
                            }

                            _context.next = 39;
                            return _iterator.return();

                          case 39:
                            _context.prev = 39;

                            if (!_didIteratorError) {
                              _context.next = 42;
                              break;
                            }

                            throw _iteratorError;

                          case 42:
                            return _context.finish(39);

                          case 43:
                            return _context.finish(34);

                          case 44:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[2, 30, 34, 44], [13, 21], [35,, 39, 43]]);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 7:
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](4);

                this._log(_context2.t0);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 9]]);
      }));

      function _onConnection(_x) {
        return _onConnection2.apply(this, arguments);
      }

      return _onConnection;
    }()
  }, {
    key: "_onPeerConnect",
    value: function _onPeerConnect(peerInfo) {
      this.bitswap._onPeerConnected(peerInfo.id);
    }
  }, {
    key: "_onPeerDisconnect",
    value: function _onPeerDisconnect(peerInfo) {
      this.bitswap._onPeerDisconnected(peerInfo.id);
    }
    /**
     * Find providers given a `cid`.
     *
     * @param {CID} cid
     * @param {number} maxProviders
     * @returns {Promise<Result<Array>>}
     */

  }, {
    key: "findProviders",
    value: function findProviders(cid, maxProviders) {
      return this.libp2p.contentRouting.findProviders(cid, {
        maxTimeout: CONSTANTS.providerRequestTimeout,
        maxNumProviders: maxProviders
      });
    }
    /**
     * Find the providers of a given `cid` and connect to them.
     *
     * @param {CID} cid
     * @returns {void}
     */

  }, {
    key: "findAndConnect",
    value: function () {
      var _findAndConnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(cid) {
        var connectAttempts, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, provider;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                connectAttempts = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _context3.prev = 3;
                _iterator2 = _asyncIterator(this.findProviders(cid, CONSTANTS.maxProvidersPerRequest));

              case 5:
                _context3.next = 7;
                return _iterator2.next();

              case 7:
                _step2 = _context3.sent;
                _iteratorNormalCompletion2 = _step2.done;
                _context3.next = 11;
                return _step2.value;

              case 11:
                _value2 = _context3.sent;

                if (_iteratorNormalCompletion2) {
                  _context3.next = 19;
                  break;
                }

                provider = _value2;

                this._log('connecting to providers', provider.id.toB58String());

                connectAttempts.push(this.connectTo(provider));

              case 16:
                _iteratorNormalCompletion2 = true;
                _context3.next = 5;
                break;

              case 19:
                _context3.next = 25;
                break;

              case 21:
                _context3.prev = 21;
                _context3.t0 = _context3["catch"](3);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t0;

              case 25:
                _context3.prev = 25;
                _context3.prev = 26;

                if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                  _context3.next = 30;
                  break;
                }

                _context3.next = 30;
                return _iterator2.return();

              case 30:
                _context3.prev = 30;

                if (!_didIteratorError2) {
                  _context3.next = 33;
                  break;
                }

                throw _iteratorError2;

              case 33:
                return _context3.finish(30);

              case 34:
                return _context3.finish(25);

              case 35:
                _context3.next = 37;
                return Promise.all(connectAttempts);

              case 37:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 21, 25, 35], [26,, 30, 34]]);
      }));

      function findAndConnect(_x3) {
        return _findAndConnect.apply(this, arguments);
      }

      return findAndConnect;
    }()
  }, {
    key: "provide",
    value: function () {
      var _provide = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(cid) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.libp2p.contentRouting.provide(cid);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function provide(_x4) {
        return _provide.apply(this, arguments);
      }

      return provide;
    }() // Connect to the given peer
    // Send the given msg (instance of Message) to the given peer

  }, {
    key: "sendMessage",
    value: function () {
      var _sendMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(peer, msg) {
        var stringId, _yield$this$_dialPeer, stream, protocol, serialized;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this._running) {
                  _context5.next = 2;
                  break;
                }

                throw new Error('network isn\'t running');

              case 2:
                stringId = peer.toB58String();

                this._log('sendMessage to %s', stringId, msg);

                _context5.next = 6;
                return this._dialPeer(peer);

              case 6:
                _yield$this$_dialPeer = _context5.sent;
                stream = _yield$this$_dialPeer.stream;
                protocol = _yield$this$_dialPeer.protocol;
                _context5.t0 = protocol;
                _context5.next = _context5.t0 === BITSWAP100 ? 12 : _context5.t0 === BITSWAP110 ? 14 : 16;
                break;

              case 12:
                serialized = msg.serializeToBitswap100();
                return _context5.abrupt("break", 17);

              case 14:
                serialized = msg.serializeToBitswap110();
                return _context5.abrupt("break", 17);

              case 16:
                throw new Error('Unknown protocol: ' + protocol);

              case 17:
                // Note: Don't wait for writeMessage() to complete
                writeMessage(stream, serialized, this._log);

                this._updateSentStats(peer, msg.blocks);

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function sendMessage(_x5, _x6) {
        return _sendMessage.apply(this, arguments);
      }

      return sendMessage;
    }()
    /**
     * Connects to another peer
     *
     * @param {PeerInfo|PeerId|Multiaddr} peer
     * @returns {Promise.<Connection>}
     */

  }, {
    key: "connectTo",
    value: function () {
      var _connectTo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(peer) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this._running) {
                  _context6.next = 2;
                  break;
                }

                throw new Error('network isn\'t running');

              case 2:
                return _context6.abrupt("return", this.libp2p.dial(peer));

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function connectTo(_x7) {
        return _connectTo.apply(this, arguments);
      }

      return connectTo;
    }() // Dial to the peer and try to use the most recent Bitswap

  }, {
    key: "_dialPeer",
    value: function _dialPeer(peer) {
      return this.libp2p.dialProtocol(peer, [BITSWAP110, BITSWAP100]);
    }
  }, {
    key: "_updateSentStats",
    value: function _updateSentStats(peer, blocks) {
      var _this2 = this;

      var peerId = peer.toB58String();

      if (this._stats) {
        blocks.forEach(function (block) {
          return _this2._stats.push(peerId, 'dataSent', block.data.length);
        });

        this._stats.push(peerId, 'blocksSent', blocks.size);
      }
    }
  }]);

  return Network;
}();

function writeMessage(_x8, _x9, _x10) {
  return _writeMessage.apply(this, arguments);
}

function _writeMessage() {
  _writeMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(stream, msg, log) {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return pipe([msg], lp.encode(), stream);

          case 3:
            _context7.next = 8;
            break;

          case 5:
            _context7.prev = 5;
            _context7.t0 = _context7["catch"](0);
            log(_context7.t0);

          case 8:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 5]]);
  }));
  return _writeMessage.apply(this, arguments);
}

module.exports = Network;